var exports = {
  "iW": "x31de4314--d984e0--main",
  "z5": "x31de4314--d984e0--main--small",
  "Db": "x31de4314--d984e0--main--large",
  "PX": "x31de4314--d984e0--main--xlarge",
  "rj": "x31de4314--d984e0--outline",
  "Qc": "x31de4314--d984e0--outline--large",
  "qo": "x31de4314--d984e0--outline--xlarge",
};

module.exports = exports;
